import { createFileRoute, Outlet, redirect } from "@tanstack/solid-router";
import { AppShell } from "~/components/layout/AppShell";
import { TokenExchangeProvider } from "~/lib/auth";

export const Route = createFileRoute("/_authenticated")({
  // Client-only: auth state lives in the browser
  ssr: false,

  beforeLoad: ({ context }) => {
    if (context.auth && !context.auth.isAuthenticated()) {
      throw redirect({ to: "/auth/login", replace: true });
    }
  },

  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <TokenExchangeProvider>
      <AppShell>
        <Outlet />
      </AppShell>
    </TokenExchangeProvider>
  );
}
